module.exports = __webpack_public_path__ + "img/BestOfQuarterIntermediateAuthoring.c356d5ba.jpg";